import React, { useEffect, useMemo, useState } from 'react';
import MasterService from '../../../../services/master/MasterService';
import TransaksiService from '../../../../services/transaksi/TransaksiService';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { FaArrowLeft, FaChevronCircleLeft, FaEdit, FaEye, FaPlus, FaSave, FaTrash } from 'react-icons/fa';
import DataTable from 'react-data-table-component';
import { AsyncPaginate } from 'react-select-async-paginate';
import SweetAlert from 'react-bootstrap-sweetalert';
import KontainerUkuran from '../../../../utilities/KontainerUkuran';
import KontainerTipe from '../../../../utilities/KontainerTipe';
import KontainerJenis from '../../../../utilities/KontainerJenis';

const ViewKontainer = ({ dataKontainer, saveKontainer, cancelKontainer }) => {
    const [showAddKontainer, setShowAddKontainer] = useState(false);
    const handleCloseAddKontainer = () => setShowAddKontainer(false);
    const handleShowAddKontainer = () => {
        setValueSeri(0)
        setShowAddKontainer(true)
    }

    const [showEditKontainer, setShowEditKontainer] = useState(false);
    const handleCloseEditKontainer = () => setShowEditKontainer(false);
    const handleShowEditKontainer = async (row) => {
        // setDetilKontainer(row)
        // console.log(row)
        setValueSeri(row.trPpkContainerPK.seri)
        const resUkuran = await masterService.getUkuranContainerById(row.ukuran)
        setValueUkuranOpt(resUkuran.data)
        setValueUkuran(row.ukuran)
        const resTipe = await masterService.getTipeContainerById(row.tipe)
        setValueTipeOpt(resTipe.data)
        setValueTipe(row.tipe)
        const resJenis = await masterService.getJenisContainerById(row.jenisStuff)
        setValueJenisOpt(resJenis.data)
        setValueJenis(row.jenisStuff)
        setValueNomorContainer(row.nomor)
        setValueNoSegel(row.nomorSegel)
        setShowEditKontainer(true)
    }

    const [showViewKontainer, setShowViewKontainer] = useState(false);
    const handleCloseViewKontainer = () => setShowViewKontainer(false);
    const handleShowViewKontainer = (row) => {
        setDetilKontainer(row)
        setShowViewKontainer(true)
    }

    const [showConfirmDelete, setShowConfirmDelete] = useState(false)
    const handleCloseConfirmDelete = () => setShowConfirmDelete(false)
    const handleShowConfirmDelete = (row) => {
        setDetilKontainer(row)
        setShowConfirmDelete(true)
    }
    const [showDeleteSuccess, setShowDeleteSuccess] = useState(false)
    const [showDeleteFailed, setShowDeleteFailed] = useState(false)

    const [detilKontainer, setDetilKontainer] = useState(null)

    let masterService = useMemo(() => new MasterService(), [])
    let transaksiService = useMemo(() => new TransaksiService(), [])

    const [listPpmContainer, setListPpmContainer] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (!dataKontainer) return
        setLoading(true)
        setListPpmContainer(dataKontainer.data)
        setTotalData(dataKontainer.totalData)
        setLoading(false)
    }, [dataKontainer])

    const handleChangePage = async (page) => {
        const response = await transaksiService.listPpmContainer(localStorage.getItem('nomorAjuStorage'), null, page, size)
        setListPpmContainer(response.data.data)
        setTotalData(response.data.totalData)
    }

    const handlePerRowsChange = async (size, page) => {
        const _res = await transaksiService.listPpmContainer(localStorage.getItem('nomorAjuStorage'), null, page - 1, size)
        setListPpmContainer(_res.data.data)
        setSize(size)
    }

    const [loadingSave, setLoadingSave] = useState(false)
    const [showConfirmSave, setShowConfirmSave] = useState(false)
    const handleCloseConfirmSave = () => setShowConfirmSave(false)
    const handleShowConfirmSave = () => setShowConfirmSave(true)

    const [showSaveSuccess, setShowSaveSucces] = useState(false)
    const [showSaveFailed, setShowSaveFailed] = useState(false)

    const [countContainer, setCountContainer] = useState(0)

    const [valueSeri, setValueSeri] = useState(0)
    const [valueUkuranOpt, setValueUkuranOpt] = useState(null)
    const [valueUkuran, setValueUkuran] = useState(null)
    const [valueTipeOpt, setValueTipeOpt] = useState(null)
    const [valueTipe, setValueTipe] = useState(null)
    const [valueJenisOpt, setValueJenisOpt] = useState(null)
    const [valueJenis, setValueJenis] = useState(null)
    const [valueNomorContainer, setValueNomorContainer] = useState(null)
    const [valueNoSegel, setValueNoSegel] = useState(null)

    async function loadOptionUkuran(search, loadedOption, { page = 1 }) {
        const response = await masterService.listUkuranContainer(search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    async function loadOptionTipe(search, loadedOption, { page = 1 }) {
        const response = await masterService.listTipeContainer(search, search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    async function loadOptionJenis(search, loadedOption, { page = 1 }) {
        const response = await masterService.listJenisContainer(search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    const onChangeUkuranOpt = e => {
        setValueUkuranOpt(e)
        setValueUkuran(e.id)
    }

    const onChangeTipeOpt = e => {
        setValueTipeOpt(e)
        setValueTipe(e.id)
    }

    const onChangeJenisOpt = e => {
        setValueJenisOpt(e)
        setValueJenis(e.id)
    }

    const onChangeNomorContainer = e => {
        setValueNomorContainer(e.target.value)
    }

    const onChangeNomorSegel = e => {
        setValueNoSegel(e.target.value)
    }

    const [kelengkapan, setKelengkapan] = useState({})
    const checkKelengkapan = () => {
        const checkKelengkapan = {}

        if (!valueNomorContainer) checkKelengkapan.nomorKontainer = 'Nomor Kontainer Wajib Diisi'
        if (!valueUkuranOpt) checkKelengkapan.ukuran = 'Ukuran Kontainer Wajib Diisi'
        if (!valueTipeOpt) checkKelengkapan.tipe = 'Tipe Kontainer Wajib Diisi'
        if (!valueJenisOpt) checkKelengkapan.jenis = 'Jenis Kontainer Wajib Diisi'

        setKelengkapan(checkKelengkapan)

        return Object.keys(checkKelengkapan).length === 0
    }

    const handleClickSimpan = async () => {
        if (checkKelengkapan()) {
            try {
                // let dataheader = JSON.parse(localStorage.getItem('dataHeaderStorage'))
                let nomorAjuStorage = localStorage.getItem('nomorAjuStorage')
                const resNextSeri = await transaksiService.nextSeri('cont', nomorAjuStorage)
                setLoadingSave(true)
                let jsonDataKontainer = {
                    jenisStuff: valueJenis,
                    nomor: valueNomorContainer,
                    nomorSegel: valueNoSegel,
                    tipe: valueTipe,
                    trPpkContainerPK: {
                        nomorAju: nomorAjuStorage,
                        seri: valueSeri !== 0 ? valueSeri : resNextSeri.data
                    },
                    ukuran: valueUkuran
                }
                const response = await transaksiService.addPpmContainer(JSON.stringify(jsonDataKontainer))
                if (response.data.kode === '200') {
                    setShowSaveSucces(true)
                    setShowConfirmSave(false)
                    setListPpmContainer([...listPpmContainer, jsonDataKontainer])
                }
                setLoadingSave(false)
                setCountContainer(countContainer + 1)
            } catch (error) {
                setLoadingSave(false)
                setShowConfirmSave(false)
                setShowSaveFailed(true)
                // console.log(error)
            }
        } else {
            setShowConfirmSave(false)
            setShowSaveFailed(true)
        }
    }

    const handleClickSaveSuccess = () => {
        setLoadingSave(false)
        setShowSaveSucces(false)
        setShowAddKontainer(false)
        setShowEditKontainer(false)
        cancelKontainer('kontainer')
        localStorage.setItem('dataKontainerStorage', listPpmContainer)
    }

    const handleClickSaveFailed = () => {
        setLoadingSave(false)
        setShowSaveFailed(false)
    }

    const handleClickDelete = async () => {
        try {
            let jsonData = {
                nomorAju: detilKontainer.trPpkContainerPK.nomorAju,
                seri: detilKontainer.trPpkContainerPK.seri
            }
            const resDelete = await transaksiService.deletePpmContainerById(jsonData)
            if (resDelete.data.kode === '200') {
                setShowConfirmDelete(false)
                setShowDeleteSuccess(true)
            }
        } catch (error) {
            setShowConfirmDelete(false)
            setShowDeleteFailed(true)
        }
    }

    const handleClickDeleteSuccess = () => {
        setShowDeleteSuccess(false)
        setShowConfirmDelete(false)
        cancelKontainer('kontainer')
        localStorage.setItem('dataKontainerStorage', listPpmContainer)
    }

    const handleClickDeleteFailed = () => {
        setShowDeleteFailed(false)
    }

    const columns = [
        {
            name: 'Seri',
            cell: row => row['trPpkContainerPK'].seri
        },
        {
            name: 'Nomor',
            cell: row => row['nomor']
        },
        {
            name: 'Tipe',
            cell: row => <KontainerTipe id={row['tipe']} />
        },
        {
            name: 'Ukuran',
            cell: row => <KontainerUkuran id={row['ukuran']} />
        },
        {
            name: 'Jenis',
            cell: row => <KontainerJenis id={row['jenisStuff']} />
        },
        {
            name: 'Action',
            cell: row => (
                <>
                    <div className='row'>
                        <div className='col-sm-3'>
                            <Button size='sm' variant='info' onClick={() => handleShowViewKontainer(row)}>
                                <FaEye />
                            </Button>
                        </div>
                        {localStorage.getItem('isEditStorage') === '1' ?
                            <>
                                <div className='col-sm-3'>
                                    <Button size='sm' variant='warning' onClick={() => handleShowEditKontainer(row)}>
                                        <FaEdit />
                                    </Button>
                                </div>
                                <div className='col-sm-3'>
                                    <Button size='sm' variant='danger' onClick={() => handleShowConfirmDelete(row)}>
                                        <FaTrash />
                                    </Button>
                                </div>
                            </> : ''
                        }
                    </div>
                </>
            )
        }
    ]

    return (
        <>
            <div className="form-card text-start">
                <div className="row">
                    <div className="col-7">
                        <h6 className="mb-4">Data Pengajuan : {localStorage.getItem('nomorAjuStorage')} </h6>
                    </div>
                </div>
                <div className="row">
                    <div className="col-7">
                        <h5 className="mb-4">Kontainer</h5>
                    </div>
                </div>
                <div className="row">
                    {
                        localStorage.getItem('isEditStorage') === '1' ?
                            <div className="col-5">
                                <Button type="button" variant="primary" size="sm" onClick={handleShowAddKontainer}><FaPlus /> Tambah Kontainer</Button>
                            </div> : ''
                    }
                </div>
            </div>
            <div className="table-responsive border-bottom my-3">
                {(loading && <Spinner />)}
                <DataTable
                    customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                    columns={columns}
                    data={listPpmContainer}
                    highlightOnHover
                    pagination
                    paginationServer
                    paginationTotalRows={totalData}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handlePerRowsChange}
                    persistTableHead={true}
                />
            </div>
            {
                localStorage.getItem('isEditStorage') === '1' ? <>
                    <button type="button" name="next" className="btn btn-primary next action-button float-end btn-sm" value="Next" onClick={() => saveKontainer('Proses')} ><FaSave /> Simpan & Lanjutkan</button>
                    <button type="button" name="previous" className="btn btn-dark previous action-button-previous float-end me-1 btn-sm" value="Previous" onClick={() => cancelKontainer('kemasan')} ><FaArrowLeft /> Sebelumnya</button>
                </> : ''
            }

            <Modal
                show={showAddKontainer}
                onHide={handleCloseAddKontainer}
                backdrop="static"
                keyboard={false}
                size='md'
            >
                <Modal.Header closeButton>
                    <Modal.Title><h5>Tambah Kontainer</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nomor Kontainer<span className='text-danger'>*</span></label>
                        <div className="col-sm-6">
                            <input type="text" className="form-control-sm" name="nomor_kontainer" placeholder="Nomor Kontainer" value={valueNomorContainer} onChange={onChangeNomorContainer} />
                        </div>
                        {kelengkapan.nomorKontainer && <div className='text-danger'>{kelengkapan.nomorKontainer}</div>}
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Ukuran Kontainer<span className='text-danger'>*</span></label>
                        <div className="col-sm-8">
                            {/* <input type="text" className="form-control-sm" name="ukuran_kontainer" placeholder="Ukurang Kontainer" /> */}
                            <AsyncPaginate
                                loadOptions={loadOptionUkuran}
                                value={valueUkuranOpt}
                                getOptionLabel={(option) => option.id + ' - ' + option.ukuranCnt}
                                getOptionValue={(option) => option.id}
                                additional={{
                                    page: 1
                                }}
                                onChange={onChangeUkuranOpt}
                            />
                            {kelengkapan.ukuran && <div className='text-danger'>{kelengkapan.ukuran}</div>}
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Tipe<span className='text-danger'>*</span></label>
                        <div className="col-sm-8">
                            {/* <input type="text" className="form-control-sm" name="tipe_kontainer" placeholder="Tipe Kontainer" /> */}
                            <AsyncPaginate
                                loadOptions={loadOptionTipe}
                                value={valueTipeOpt}
                                getOptionLabel={(option) => option.kode + ' - ' + option.typeCnt}
                                getOptionValue={(option) => option.id}
                                additional={{
                                    page: 1
                                }}
                                onChange={onChangeTipeOpt}
                            />
                            {kelengkapan.tipe && <div className='text-danger'>{kelengkapan.tipe}</div>}
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Jenis Kontainer<span className='text-danger'>*</span></label>
                        <div className="col-sm-8">
                            {/* <input type="text" className="form-control-sm" name="jenis_kontainer" placeholder="Jenis Kontainer" /> */}
                            <AsyncPaginate
                                loadOptions={loadOptionJenis}
                                value={valueJenisOpt}
                                getOptionLabel={(option) => option.id + ' - ' + option.jenisCnt}
                                getOptionValue={(option) => option.id}
                                additional={{
                                    page: 1
                                }}
                                onChange={onChangeJenisOpt}
                            />
                            {kelengkapan.jenis && <div className='text-danger'>{kelengkapan.jenis}</div>}
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nomor Segel</label>
                        <div className="col-sm-6">
                            <input type="text" className="form-control-sm" name="no_segel" placeholder="Nomor Segel" value={valueNoSegel} onChange={onChangeNomorSegel} />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseAddKontainer} size='sm'>
                        <FaChevronCircleLeft /> Close
                    </Button>
                    <Button variant="primary" onClick={handleShowConfirmSave} size='sm'><FaSave /> Simpan</Button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={showEditKontainer}
                onHide={handleCloseEditKontainer}
                backdrop="static"
                keyboard={false}
                size='md'
            >
                <Modal.Header closeButton>
                    <Modal.Title><h5>Ubah Kontainer</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nomor Kontainer<span className='text-danger'>*</span></label>
                        <div className="col-sm-6">
                            <input type="text" className="form-control-sm" name="nomor_kontainer" placeholder="Nomor Kontainer" value={valueNomorContainer} onChange={onChangeNomorContainer} />
                        </div>
                        {kelengkapan.nomorKontainer && <div className='text-danger'>{kelengkapan.nomorKontainer}</div>}
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Ukuran Kontainer<span className='text-danger'>*</span></label>
                        <div className="col-sm-8">
                            {/* <input type="text" className="form-control-sm" name="ukuran_kontainer" placeholder="Ukurang Kontainer" /> */}
                            <AsyncPaginate
                                loadOptions={loadOptionUkuran}
                                value={valueUkuranOpt}
                                getOptionLabel={(option) => option.id + ' - ' + option.ukuranCnt}
                                getOptionValue={(option) => option.id}
                                additional={{
                                    page: 1
                                }}
                                onChange={onChangeUkuranOpt}
                            />
                            {kelengkapan.ukuran && <div className='text-danger'>{kelengkapan.ukuran}</div>}
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Tipe<span className='text-danger'>*</span></label>
                        <div className="col-sm-8">
                            {/* <input type="text" className="form-control-sm" name="tipe_kontainer" placeholder="Tipe Kontainer" /> */}
                            <AsyncPaginate
                                loadOptions={loadOptionTipe}
                                value={valueTipeOpt}
                                getOptionLabel={(option) => option.kode + ' - ' + option.typeCnt}
                                getOptionValue={(option) => option.id}
                                additional={{
                                    page: 1
                                }}
                                onChange={onChangeTipeOpt}
                            />
                            {kelengkapan.tipe && <div className='text-danger'>{kelengkapan.tipe}</div>}
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Jenis Kontainer<span className='text-danger'>*</span></label>
                        <div className="col-sm-8">
                            {/* <input type="text" className="form-control-sm" name="jenis_kontainer" placeholder="Jenis Kontainer" /> */}
                            <AsyncPaginate
                                loadOptions={loadOptionJenis}
                                value={valueJenisOpt}
                                getOptionLabel={(option) => option.id + ' - ' + option.jenisCnt}
                                getOptionValue={(option) => option.id}
                                additional={{
                                    page: 1
                                }}
                                onChange={onChangeJenisOpt}
                            />
                            {kelengkapan.jenis && <div className='text-danger'>{kelengkapan.jenis}</div>}
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nomor Segel</label>
                        <div className="col-sm-6">
                            <input type="text" className="form-control-sm" name="no_segel" placeholder="Nomor Segel" value={valueNoSegel} onChange={onChangeNomorSegel} />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseEditKontainer} size='sm'>
                        <FaChevronCircleLeft /> Close
                    </Button>
                    <Button variant="primary" onClick={handleShowConfirmSave} size='sm'><FaSave /> Simpan</Button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={showViewKontainer}
                onHide={handleCloseViewKontainer}
                backdrop="static"
                keyboard={false}
                size='md'
            >
                <Modal.Header closeButton>
                    <Modal.Title><h5>Lihat Kontainer</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nomor Kontainer</label>
                        <div className="col-sm-6">
                            <input type="text" className="form-control-sm" name="nomor_kontainer" placeholder="Nomor Kontainer" value={detilKontainer !== null ? detilKontainer.nomor : ''} />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Ukuran Kontainer</label>
                        <div className="col-sm-8">
                            {detilKontainer !== null ? <KontainerUkuran id={detilKontainer.ukuran} /> : ''}
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Tipe</label>
                        <div className="col-sm-8">
                            {detilKontainer !== null ? <KontainerTipe id={detilKontainer.tipe} /> : ''}
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Jenis Kontainer</label>
                        <div className="col-sm-8">
                            {detilKontainer !== null ? <KontainerJenis id={detilKontainer.jenisStuff} /> : ''}
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nomor Segel</label>
                        <div className="col-sm-6">
                            <input type="text" className="form-control-sm" name="no_segel" placeholder="" value={detilKontainer !== null ? detilKontainer.nomorSegel : ''} disabled />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseViewKontainer} size='sm'>
                        <FaChevronCircleLeft /> Close
                    </Button>
                </Modal.Footer>
            </Modal>
            {
                showConfirmSave &&
                <SweetAlert
                    title="Simpan Data Kontainer?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSave ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Simpan"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickSimpan}
                    onCancel={handleCloseConfirmSave}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingSave}
                >
                    {loadingSave && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showSaveSuccess &&
                <SweetAlert
                    success
                    title="Simpan Data Kontainer Berhasil"
                    onConfirm={handleClickSaveSuccess}
                    btnSize="sm"
                />
            }
            {
                showSaveFailed &&
                <SweetAlert
                    danger
                    title="Simpan Data Kontainer Gagal"
                    onConfirm={handleClickSaveFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
            {
                showConfirmDelete &&
                <SweetAlert
                    title="Hapus Data Kontainer?"
                    warning
                    showCancel
                    confirmBtnText="Hapus"
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickDelete}
                    onCancel={handleCloseConfirmDelete}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingSave}
                >Data Kontainer : {detilKontainer !== null ? detilKontainer.nomor : ''}</SweetAlert>
            }
            {
                showDeleteSuccess &&
                <SweetAlert
                    success
                    title="Hapus Data Kontainer Berhasil"
                    onConfirm={handleClickDeleteSuccess}
                    btnSize="sm"
                />
            }
            {
                showDeleteFailed &&
                <SweetAlert
                    danger
                    title="Hapus Data Kontainer Gagal"
                    onConfirm={handleClickDeleteFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default ViewKontainer